<template>
  <div class="home_post_list">
    <section class="home-post-section home-section">
      <div class="home-section-header">Latest-Post</div>
      <div class="post-list-wrapper home-section-wrapper">
        <PostList class="row1" rowsNumber="1" maxNumber="5" />
        <PostList class="row2" rowsNumber="2" maxNumber="5" />
        <PostList class="row3" rowsNumber="3" maxNumber="5" />
      </div>
      <div class="more-posts">
        <span @click="handleRouter('all')">Read More</span>
      </div>
    </section>
    <section class="home-vision-section home-section">
      <div class="home-section-header">vision</div>
      <div class="vision-list-wrapper photo-list home-section-wrapper">
        <div
          class="single-photo-parent"
          v-for="(item, index) in photoLatest"
          :key="index"
          v-show="index <= 3"
        >
          <img :src="item.url" :alt="item.description" class="img-responsive" />
          <div class="photo-info">
            <span
              class="tags"
              v-for="(tag, index) in item.tags"
              :key="`${tag}-${index}`"
              >{{ tag }}</span
            >
          </div>
        </div>
      </div>
      <div class="more-posts">
        <span @click="handleRouter('gallery')">View All</span>
      </div>
    </section>
    <section class="home-opensource-section home-section">
      <div class="home-section-header">Open-Source</div>
      <div class="opensource-list-wrapper">
        <article class="opensource-item-wrapper home-section-wrapper">
          <a class="opensource-item" href="https://github.com/dendoink/Align">
            <div class="opensource-item-header">
              <img
                class="opensource-item-header-img"
                src="../assets/align_logo.png"
              />
            </div>
            <div class="opensource-info-content">
              <h3 class="opensource-name">Align</h3>
              <p class="opensource-description">
                Real-time, Beautiful blog generator, Auto deploy
              </p>
            </div>
          </a>
        </article>
        <article class="opensource-item-wrapper home-section-wrapper">
          <a class="opensource-item" href="https://www.frontendwingman.com/">
            <div class="opensource-item-header">
              <img
                class="opensource-item-header-img"
                src="../assets/wingman_logo.png"
                :style="`background: #ffffff`"
              />
            </div>
            <div class="opensource-info-content">
              <h3 class="opensource-name">Frontend Wingman</h3>
              <p class="opensource-description">Learn frontend faster!</p>
            </div>
          </a>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { postData } from "../utils/data.js";
import { getAllCategories } from "../utils/datafilter.js";
import { photoData } from "../utils/photoData";
export default {
  // 主页
  name: "Home",
  data() {
    return {
      allPosts: JSON.parse(postData),
      categories: getAllCategories(JSON.parse(postData)),
      photoLatest: photoData,
    };
  },
  components: {
    PostList: () => import("../components/PostList"),
  },
  methods: {
    handleRouter: function (dir, categorie = "") {
      let path;
      if (categorie) {
        path = `/${dir}?${dir}=${categorie}`;
      } else {
        path = `/${dir}`;
      }
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 800px;
  width: 800px;
  margin: 0 auto;
  position: relative;
}
.home_post_list {
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;
}
.post-list-wrapper {
  display: flex;
}
.home-section {
  margin-bottom: 2rem;
}
.home-section .home-section-wrapper {
  margin-top: 2rem;
}
.home-section .home-section-header {
  display: block;
  text-transform: uppercase;
  font-size: 0.55rem;
  letter-spacing: 8.6px;
  opacity: 0.7;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ccc;
  margin-top: 2rem;
  text-align: left;
  padding-left: 4rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
}
.opensource-list-wrapper,
.vision-list-wrapper {
  padding: 0rem 4rem !important;
}
.opensource-list-wrapper {
  display: flex;
  justify-content: flex-start;
}
.opensource-list-wrapper .opensource-item-wrapper {
  display: flex;
  width: 20%;
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: calc(0.25rem - 1px);
  margin-right: 48px;
}

.opensource-item-wrapper .opensource-info-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
  margin-top: 16px;
}

.opensource-item-wrapper .opensource-item-header {
  background: #f05a5a;
}

.opensource-item-header-img {
  width: 100%;
  height: auto;
  border: 1px solid #cccccc36;
}
.opensource-item-wrapper .opensource-item {
  background-size: cover;
  background-position: center top;
  color: #585858;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.opensource-item-wrapper:hover {
  -webkit-animation: wobble-hor-bottom 0.8s both;
  animation: wobble-hor-bottom 0.8s both;
}
.home-section .home-section-header::first-letter {
  color: #42b983;
  font-size: 1.5rem;
}
.home-section .more-posts {
  font-size: 1rem;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.home-section .more-posts span {
  padding: 0.2rem 1rem;
  border: 2px solid #ef00ff;
  border-radius: 4px;
  opacity: 0.5;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  font-size: 1.3rem;
}
.home-section .more-posts span:hover {
  color: #ef00ff;
  border-color: #ffffff;
  opacity: 0.9;
}
@media screen and (max-width: 1000px) and (min-width: 300px) {
  .home_post_list {
    display: flex;
    flex-direction: column;
  }
}

.photo-list {
  max-width: 100%;
  display: flex;
  padding: 1rem;
  justify-content: flex-start;
}
.photo-list .single-photo-parent {
  position: relative;
  display: inline-block;
  height: fit-content;
  transition: all 0.2s ease-in-out;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
  margin-right: 1rem;
}
.single-photo-parent img {
  height: auto;
  max-width: 400px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-top-right-radius: calc(0.25rem - 1px);
  border-top-left-radius: calc(0.25rem - 1px);
}

.single-photo-parent:hover {
  -webkit-box-shadow: 0 18px 32px -18px #000;
  box-shadow: 0 18px 32px -18px #000;
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}
.single-photo-parent .photo-info {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
  display: flex;
  opacity: 0;
  justify-content: center;
  color: #ffffff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.34) 0,
    rgba(0, 0, 0, 0.338) 3.5%,
    rgba(0, 0, 0, 0.324) 7%,
    rgba(0, 0, 0, 0.306) 10.35%,
    rgba(0, 0, 0, 0.285) 13.85%,
    rgba(0, 0, 0, 0.262) 17.35%,
    rgba(0, 0, 0, 0.237) 20.85%,
    rgba(0, 0, 0, 0.213) 24.35%,
    rgba(0, 0, 0, 0.188) 27.85%,
    rgba(0, 0, 0, 0.165) 31.35%,
    rgba(0, 0, 0, 0.144) 34.85%,
    rgba(0, 0, 0, 0.126) 38.35%,
    rgba(0, 0, 0, 0.112) 41.85%,
    rgba(0, 0, 0, 0.103) 45.35%,
    rgba(0, 0, 0, 0.1) 48.85%,
    rgba(0, 0, 0, 0.103) 52.35%,
    rgba(0, 0, 0, 0.112) 55.85%,
    rgba(0, 0, 0, 0.126) 59.35%,
    rgba(0, 0, 0, 0.144) 62.85%,
    rgba(0, 0, 0, 0.165) 66.35%,
    rgba(0, 0, 0, 0.188) 69.85%,
    rgba(0, 0, 0, 0.213) 73.35%,
    rgba(0, 0, 0, 0.237) 76.85%,
    rgba(0, 0, 0, 0.262) 80.35%,
    rgba(0, 0, 0, 0.285) 83.85%,
    rgba(0, 0, 0, 0.306) 87.35%,
    rgba(0, 0, 0, 0.324) 90.85%,
    rgba(0, 0, 0, 0.338) 94.35%,
    rgba(0, 0, 0, 0.347) 97.85%,
    rgba(0, 0, 0, 0.35)
  );
}

.photo-info .tags {
  margin-top: 8px;
  margin-right: 4px;
  font-size: 1rem;
}

.single-photo-parent:hover .photo-info {
  display: flex;
  opacity: 1;
  cursor: pointer;
}
.photo-info span {
  text-transform: uppercase;
  transition: all 0.2s ease-in-out;
  font-size: 0.5rem;
}
/* ----------------------------------------------
 * Generated by Animista on 2018-12-18 6:46:16
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation wobble-hor-bottom
 * ----------------------------------------
 */
@-webkit-keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
    transform: translateX(-6px) rotate(-1.2deg);
  }
}
@keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
    transform: translateX(-6px) rotate(-1.2deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue